var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ReportDataTable',{attrs:{"urls":_vm.urls,"page":_vm.page}})
}
var staticRenderFns = []

export { render, staticRenderFns }